import React from "react";
import { X } from "lucide-react";
import TimeSpinner from "./ui/TimeSpinner";
import { parse } from "date-fns";

interface TimePickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTime: string;
  onSelectTime: (time: string) => void;
}

const TimePickerModal: React.FC<TimePickerModalProps> = ({
  isOpen,
  onClose,
  selectedTime,
  onSelectTime,
}) => {
  if (!isOpen) return null;

  // Convert string time (e.g. "9:00 AM") to Date for TimeSpinner
  const getParsedDate = () => {
    try {
      if (!selectedTime) return new Date();
      return parse(selectedTime, "h:mm aa", new Date());
    } catch (e) {
      return new Date();
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/20 backdrop-blur-[1px] z-[2000]"
        onClick={onClose}
      />

      {/* Modal - Compact */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-fit bg-white rounded-2xl shadow-2xl z-[2001] flex flex-col overflow-hidden border border-gray-100 p-6 sm:p-8">
        {/* Label */}
        <div className="text-center mb-4">
          <span className="text-[10px] font-bold text-[#885ABB] uppercase tracking-[0.2em]">Time</span>
        </div>

        {/* Spinner Area */}
        <div className="flex items-center justify-center">
          <TimeSpinner
            date={getParsedDate()}
            onChange={(time24: string) => {
              // Convert 24h "HH:mm" to 12h "h:mm aa"
              const [h, m] = time24.split(":");
              const date = new Date();
              date.setHours(parseInt(h, 10));
              date.setMinutes(parseInt(m, 10));
              const time12 = date.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              });
              onSelectTime(time12);
            }}
          />
        </div>

        {/* Footer Actions */}
        <div className="mt-6 flex justify-center">
          <button
            onClick={onClose}
            className="px-8 py-2 bg-[#885ABB] text-white rounded-lg font-bold hover:bg-[#7748A4] transition-all shadow-md text-xs uppercase tracking-wider"
          >
            Done
          </button>
        </div>
      </div>
    </>
  );
};

export default TimePickerModal;
